import React, { useCallback, useState } from 'react';
import Particles from 'react-tsparticles';
import { loadFull } from 'tsparticles';
import axios from 'axios';
import deepmerge from 'deepmerge';
import * as c from '../../ts/const';
const ParticlesBox = ({ children, id, settingsFile, largeSettingsFile, smallSettingsFile }) => {
    const [particlesSettings, setParticlesSettings] = useState({});
    //
    // パーティクル設定データの取得と初期化
    const onInitParticles = useCallback(async (engine) => {
        const res = await Promise.all([
            axios.get(settingsFile),
            axios.get(largeSettingsFile),
            axios.get(smallSettingsFile)
        ]);
        if (c.IS_MOBILE.matches) {
            setParticlesSettings(deepmerge.all([res[0].data, res[2].data]));
        }
        else {
            setParticlesSettings(deepmerge.all([res[0].data, res[1].data]));
        }
        c.IS_MOBILE.addEventListener('change', async () => {
            if (c.IS_MOBILE.matches) {
                setParticlesSettings(deepmerge.all([res[0].data, res[2].data]));
            }
            else {
                setParticlesSettings(deepmerge.all([res[0].data, res[1].data]));
            }
            await loadFull(engine);
        });
        await loadFull(engine);
    }, []);
    return (React.createElement("div", { className: "relative" },
        React.createElement(Particles, { id: id, params: particlesSettings, init: onInitParticles }),
        React.createElement("div", { className: "relative z-10" }, children)));
};
export default ParticlesBox;
